// <s-load-more> appends the next collection page into #product-grid instead of navigating.
// The "show more" link keeps a real next-page href, so it still works as plain pagination without JavaScript.
// After loading, the status block (progress bar, count, link) is replaced with the fetched page's version.
class LoadMore extends HTMLElement {
  #controller = null;
  #busy = false;

  connectedCallback() {
    this.#controller = new AbortController();
    this.addEventListener('click', (event) => {
      const link = event.target.closest('[data-load-more-link]');
      if (!link || !this.contains(link)) return;
      event.preventDefault();
      this.#load(link);
    }, { signal: this.#controller.signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  async #load(link) {
    if (this.#busy) return;
    const grid = document.getElementById('product-grid');
    if (!grid) {
      window.location.href = link.href;
      return;
    }
    this.#busy = true;
    link.setAttribute('aria-busy', 'true');
    link.classList.add('opacity-60', 'pointer-events-none');
    try {
      const response = await fetch(link.href, { signal: this.#controller.signal });
      if (!response.ok) throw new Error(String(response.status));
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const items = Array.from(doc.querySelectorAll('#product-grid > li'));
      const firstNew = items[0];
      items.forEach((item) => grid.appendChild(document.importNode(item, true)));
      const nextStatus = doc.querySelector('s-load-more');
      this.innerHTML = nextStatus ? nextStatus.innerHTML : '';
      if (firstNew) {
        const appended = grid.children[grid.children.length - items.length];
        appended?.querySelector('a')?.focus({ preventScroll: true });
      }
    } catch (error) {
      if (error.name !== 'AbortError') window.location.href = link.href;
    } finally {
      this.#busy = false;
    }
  }
}

if (!customElements.get('s-load-more')) customElements.define('s-load-more', LoadMore);
